export type PromotionMode = "qr" | "redeem";

export const PROMOTION_STATUS = {
  ACTIVE: 1,
  DEACTIVATED: 2,
  DELETED: 99,
} as const;

export type PromotionStatus =
  | typeof PROMOTION_STATUS.ACTIVE
  | typeof PROMOTION_STATUS.DEACTIVATED
  | typeof PROMOTION_STATUS.DELETED;

export interface Promotion {
  id: number;
  trackingId: string;
  campaignName: string;
  totalDonations: number;
  donationsPerUser: number;
  foodBarsPerDonation: number;
  isMetered: boolean;
  status: PromotionStatus;
  donationCount: number;
}

export type CreatePromotionPayload = Omit<Promotion, "id" | "donationCount"> & {
  donationCount?: number;
};

export type UpdatePromotionPayload = Promotion;

export interface PromotionFormValues {
  mode: PromotionMode;
  campaignName: string;
  trackingId: string;
  totalDonations: number;
  donationsPerUser: number;
  foodBarsPerDonation: number;
  isMetered: boolean;
}
